import { checkPermission as robustCheckPermission } from "./CheckPremission";

export const checkPermission = (loginUserData, permissionType, action) => {
  return robustCheckPermission(loginUserData, permissionType, action);
};
